/*
This code is protected under a copyright with DMCA. Copyright #845f8969-02c1-4493-af09-37ab22253c76 And ChocoCRM Ltd Company Do not redistribute, steal, or otherwise use in your code with or without credit, or we will take legal action.
Create By FutaraDragon and ChocoCRM Ltd Company.

Version 1.41 (2023-08-04 12:15)
*/

console.log("EDM Engine Loaded")

var EDMGlobalStyle = document.createElement("style");
EDMGlobalStyle.type = "text/css";
var EDMGlobalStyleData = "";
EDMGlobalStyleData = EDMGlobalStyleData + ".bypass { pointer-events:none; }";
EDMGlobalStyleData = EDMGlobalStyleData + ".render { pointer-events:all; }";
EDMGlobalStyleData = EDMGlobalStyleData + ".display-none { display:none; }";
EDMGlobalStyleData = EDMGlobalStyleData + ".absolute { position:absolute; }";
EDMGlobalStyleData = EDMGlobalStyleData + ".relative { position:relative; }";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-row-selector { position:relative; width:100%; min-width:600px; margin:0 auto auto auto; box-sizing: border-box;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-row-selector>table { pointer-events:none;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-row-selector-ui-overlay { position:absolute; top:0; left:0; width:100%; height:100%; pointer-events:none;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-row-selector-ui { position:absolute; top:0; left:0; width:100%; height:100%; outline:2px solid rgba(0,0,0,0); outline-offset: -2px; pointer-events:all;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-row-selector-ui:hover { outline:2px solid rgba(0,0,0,1);}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-col-data {position: relative; width:100%; height:100%;}"
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-col-selector { position:relative; pointer-events:none;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-col-selector-ui-overlay { position:absolute; top:0; left:0; width:100%; height:100%; pointer-events:none;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-col-selector-ui { position:absolute; top:0; left:0; width:100%; height:100%; outline:2px solid rgba(0,0,0,0); outline-offset: -2px; pointer-events:all;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-col-selector-ui:hover { outline:2px solid rgba(0,0,0,1);}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-content-selector { position:relative; pointer-events:none;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-content-selector-ui { position:absolute; top:0; left:0; width:100%; height:100%; outline:2px solid rgba(0,0,0,0); outline-offset: -2px; pointer-events:all;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-content-selector-ui:hover { outline:2px solid rgba(0,0,0,1);}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-blank { display:flex; flex-direction:column; justify-content:center; text-align:center; width:100%; height:300px; background-color:#FFF; border:2px solid #999; box-sizing: border-box;}";
EDMGlobalStyleData = EDMGlobalStyleData + ".edm-editor-base.edm-display-mode * { min-height:0px;}";

EDMGlobalStyle.innerHTML = EDMGlobalStyleData;
document.getElementsByTagName("head")[0].appendChild(EDMGlobalStyle);

var EDMEditor = {};
var EDMEditorRuntime = {};

window.EDMInitEditor = function(EditorId,QueryDom,ConfigOverride) {
	if(EDMEditor[EditorId]) { console.error("id already exist"); return; };
	let EditorDom = document.querySelector(QueryDom);
	if(!EditorDom) { console.error("dom not found"); return; };
	EDMEditor[EditorId] = {
		Id:EditorId,
		Obj:{},
		ObjMapping:[],
		Properties:{
			BaseLayout:{
				Style:{
					['background-color']:'#EEEEEE',
					['background-size']:'unset',
					['background-image']:'unset',
					['background-position']:'unset',
				}
			},
			AfterContentHtml:'',
		},
	};
	EDMEditorRuntime[EditorId] = {
		Id:EditorId,
		QueryDom:QueryDom,
		Dom:EditorDom,
		BaseDom:null,
		BaseAreaDom:null,
		BaseFrameDom:null,
		BaseEditorDom:null,
		DynamicCSSDom:null,
		ScrollTop:0,
		ScrollEvent:[],
		Event:[],
		MouseClickAction:true,
		EventAction:{},
		Properties:{
			SelectObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseHoverObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDownObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseUpObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragStartObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragEndObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragOverObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragStartObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragEnterObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDragLeaveObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
			MouseDropStartObject:{
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option:{
					RowSide:'Default',
					ColSide:'Default',
					MouseX:0,
					MouseY:0,
				},
			},
		},
		Config:{
			EditMode:"editable", //"editable,readonly"
			ViewMode:"modern", //"modern,legacy"
			TableDataLength:50,
			FixContentAreaSize:600,
			AreaManagementStyle:{
				['width']:'100%',
				['min-width']:'600px',
				['margin']:'0 auto auto auto',
				['border']:'none',
				['border-spacing']:'0px',
				['border-collapse']:'collapse',
			},
			AreaManagementFrameStyle:{
				['width']:'100%',
				['min-width']:'600px',
				['margin']:'0 auto auto auto',
				['border']:'none',
				['border-spacing']:'0px',
				['border-collapse']:'collapse',
			},
			LegacyFilterOut:[
				'background-image',
				'border-radius',
				'display',
			],
			GlobalAttribute:{
				table:{},
				td:{},
			},
			GlobalClass:{
				table:[],
				td:[],
			},
			GlobalStyle:{
				table:{
					['width']:'600px',
					['border']:'0px',
					['border-spacing']:'0px',
					['border-collapse']:'collapse',
					['margin-left']:'auto',
					['margin-right']:'auto',
				},
				td:{
					['position']:'relative',
					['padding']:'0px',
				},
			},
			DefaultAttribute:{
				table:{},
			},
			DefaultClass:{
				table:[],
			},
			DefaultStyle:{
				table:{
					['background-color']:'#FFFFFF',
				},
			},
			ContentAttribute:{
				table:{},
				td:{},
			},
			ContentClass:{
				table:[],
				td:[],
			},
			ContentStyle:{
				table:{
					['width']:'100%',
					['border']:'0px',
					['border-spacing']:'0px',
					['border-collapse']:'collapse',
					['margin-left']:'auto',
					['margin-right']:'auto',
				},
				td:{
					['padding']:'0px',
				}
			},
			UIRowEventAttribute:{},
			UIRowEventClass:[],
			UIRowEventStyle:{},
			UIRowAttribute:{},
			UIRowClass:[],
			UIRowStyle:{},
			UIColAttribute:{},
			UIColClass:[],
			UIColStyle:{},
			UIContentAttribute:{},
			UIContentClass:[],
			UIContentStyle:{},
			ContentPlugin:{},
			EventFunction:{
				Click:{},
				Hover:{},
				Up:{},
				Down:{},
				Drag:{},
				DragStart:{},
				DragEnd:{},
				DragOver:{},
				DragEnter:{},
				DragLeave:{},
				Drop:{},
			},
		},
	};
	
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	
	if(ConfigOverride){
		let ConfigKeys = Object.keys(ConfigOverride)
		for(let F = 0;F < ConfigKeys.length;F++){
			EditorRT.Config[ConfigKeys[F]] = ConfigOverride[ConfigKeys[F]];
		}
	}
	
	EditorDom.innerHTML = "";
	EditorDom.classList.add("edm-editor-base");
	EditorDom.classList.add("relative");
	EditorDom.setAttribute("draggable","false");
	
	let BaseDom = document.createElement("div");
	BaseDom.classList.add("edm-editor-area-management");
	BaseDom.setAttribute("id",EditorId);
	BaseDom.setAttribute("draggable","false");
	EditorDom.appendChild(BaseDom)
	EditorRT.BaseDom = BaseDom;
	
	let BaseEditorDom = document.createElement("div");
	BaseEditorDom.classList.add("edm-editor-area-management-frame");
	BaseEditorDom.setAttribute("draggable","false");
	BaseDom.appendChild(BaseEditorDom)
	EditorRT.BaseEditorDom = BaseEditorDom;
	
	EDMAddScrollEvent(EditorId,EditorRT.Dom,(EventObject)=>{
		EditorRT.ScrollTop = EditorRT.Dom.scrollTop;
	})
};

window.EDMUnInitEditor = function(EditorId) {
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	EDMClearScrollEvent(EditorId);
	EDMClearEvent(EditorId);
	EditorRT.Dom.innerHTML = "";
	EditorRT.Dom.classList.remove("edm-editor-base");
	EditorRT.Dom.classList.remove("relative");
	EditorRT.Dom.removeAttribute("draggable");
	delete EDMEditor[EditorId];
	delete EDMEditorRuntime[EditorId];
}

window.EDMGetEditor = function(EditorId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	return Editor;
}

window.EDMGetEditorRunTime = function(EditorId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	return EditorRT;
}

window.EDMGetObjList = function(EditorId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	return Editor.Obj;
}

window.EDMGetObjMappingList = function(EditorId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	return Editor.ObjMapping;
}

window.EDMGetProperties = function(EditorId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	return Editor.Properties;
}

window.EDMGetRowMapping = function(EditorId,EDMRowId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === CurrentRow.Id) TargetRowIdx = Idx;
	})
	
	if (TargetRowIdx != -1){
		return Editor.ObjMapping[TargetRowIdx];
	}
	
	return null;
}

window.EDMGetContentFromCol = function(EditorId,EDMColId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };

	let CurrentCol = Editor.Obj[EDMColId];
	if(!CurrentCol || CurrentCol.Type != 'Col') { console.error("column not found"); return; };
	
	let ObjKeys = Object.keys(Editor.Obj)
	for(let F = 0;F < ObjKeys.length;F++){
		if(Editor.Obj[ObjKeys[F]].ColId == CurrentCol.Id && Editor.Obj[ObjKeys[F]].Type == "Content"){
			return Editor.Obj[ObjKeys[F]];
		}
	}
	return null;
}

window.EDMCalculateColResizeDrag = function(EditorId,MinArea,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let ReturnObj = {
		Col1Id: null,
		Col1Length: 0,
		Col2Id: null,
		Col2Length: 0,
	}
	
	if(EditorRT.Properties.MouseHoverObject.ColId != null){
		let RowId = EditorRT.Properties.MouseHoverObject.RowId;
		let ColId = EditorRT.Properties.MouseHoverObject.ColId;
		let TargetColObject = EditorRT.Dom.querySelector('#' + ColId);
		if (TargetColObject == null) { console.error("col dom not found"); return; }
		
		let ColInRow = EDMGetRowMapping(EditorId,RowId).Col;
		
		MinArea = Math.max(1,MinArea);
		
		let MouseX = EditorRT.Properties.MouseHoverObject.Option.MouseX;
		
		let ObjX = EDMGetObjectOffset(TargetColObject).left;
		let ObjW = TargetColObject.clientWidth;
		let Center = ObjX + (ObjW / 2);
		let ColSide = MouseX > Center ? 'After' : 'Before';

		let ScrollTogglePlus = EditorRT.Config.TableDataLength;
		let ScrollToggle = ScrollTogglePlus / 2;
		
		let ColIndex = -1;
		
		let ColChainId = null;
		let MaxArea = 0;
		let TargetX = MouseX;
		
		let ColLength = Editor.Obj[ColId].Properties.Length;
		let ColChainLength = 0;
		
		for(let F = 0;F < ColInRow.length;F++){
			if(ColId == ColInRow[F].Id){ColIndex = F; break;}
		}
		
		let TogglePlusScroll = function (){
			ScrollToggle += ScrollTogglePlus;
						
			ColLength = Math.max(MinArea,ColLength - 1);
			ColChainLength = MaxArea - ColLength;
		}
		
		if (ColIndex != -1){
			if (ColSide == 'Before'){
				if(ColIndex > 0){
					ColChainId = ColInRow[ColIndex - 1].Id;
					ColChainLength = Editor.Obj[ColChainId].Properties.Length;
					MaxArea = ColLength + ColChainLength;
					
					while(MouseX > (ObjX + ScrollToggle)){
						TogglePlusScroll();
					}
				}
			}else if(ColSide == 'After'){
				if(ColIndex < ColInRow.length - 1){
					ColChainId = ColInRow[ColIndex + 1].Id;
					ColChainLength = Editor.Obj[ColChainId].Properties.Length;
					MaxArea = ColLength + ColChainLength;
					
					while(MouseX < ((ObjX + ObjW) - ScrollToggle)){
						TogglePlusScroll();
					}
				}
			}
			
			ReturnObj.Col1Id = ColId;
			ReturnObj.Col1Length = ColLength;
			ReturnObj.Col2Id = ColChainId;
			ReturnObj.Col2Length = ColChainLength;
		}
	}
	
	return ReturnObj
}

window.EDMAddRow = function(EditorId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let GenId = EDMGetRandomId();
	
	while(Editor[GenId] != null){
		GenId = EDMGetRandomId();
	}
	
	let BlockConfig = {
		Id:GenId,
		Type:"Row",
		Properties:{},
	}
	
	if(OptionConfig.Properties != null){
		let ConfigKeys = Object.keys(OptionConfig.Properties)
		for(let F = 0;F < ConfigKeys.length;F++){
			BlockConfig.Properties[ConfigKeys[F]] = OptionConfig.Properties[ConfigKeys[F]];
		}
	}
	
	Editor.Obj[GenId] = BlockConfig;
	
	let BlockMappingConfig = {
		Id:GenId,
		Col:[],
	}
	
	if(OptionConfig.TargetObjId != null){
		let TargetRowIdx = -1
		Editor.ObjMapping.map((Obj,Idx) => {
			if(Obj.Id === OptionConfig.TargetObjId) TargetRowIdx = Idx;
		})
		if(TargetRowIdx != -1){
			if(OptionConfig.TargetAddType == "Before"){
				Editor.ObjMapping.splice(TargetRowIdx, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				Editor.ObjMapping.splice(TargetRowIdx + 1, 0, BlockMappingConfig);
			}else{
				Editor.ObjMapping.push(BlockMappingConfig);
			}
		}else{
			Editor.ObjMapping.push(BlockMappingConfig);
		}
	}else if(OptionConfig.TargetAddType != null){
		if(OptionConfig.TargetAddType == "Before"){
			Editor.ObjMapping.splice(0, 0, BlockMappingConfig);
		}else if(OptionConfig.TargetAddType == "After"){
			Editor.ObjMapping.push(BlockMappingConfig);
		}else{
			Editor.ObjMapping.push(BlockMappingConfig);
		}
	}else{
		Editor.ObjMapping.push(BlockMappingConfig);
	}
	
	return GenId;
}

window.EDMAddCol = function(EditorId,EDMRowId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	let RowMapping = Editor.ObjMapping[TargetRowIdx];
	
	let GenId = EDMGetRandomId();
	
	while(Editor[GenId] != null){
		GenId = EDMGetRandomId();
	}
	
	let BlockConfig = {
		Id:GenId,
		Type:"Col",
		Properties:{
			Length: 12,
		},
	}
	
	if(OptionConfig.Properties != null){
		let ConfigKeys = Object.keys(OptionConfig.Properties)
		for(let F = 0;F < ConfigKeys.length;F++){
			BlockConfig.Properties[ConfigKeys[F]] = OptionConfig.Properties[ConfigKeys[F]];
		}
	}
	
	Editor.Obj[GenId] = BlockConfig;
	
	let BlockMappingConfig = {
		Id:GenId,
	}
	
	if(OptionConfig.TargetObjId != null){
		let TargetColIdx = -1
		RowMapping.Col.map((Obj,Idx) => {
			if(Obj.Id === OptionConfig.TargetObjId) TargetColIdx = Idx;
		})
		if(TargetColIdx != -1){
			if(OptionConfig.TargetAddType == "Before"){
				RowMapping.Col.splice(TargetColIdx, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				RowMapping.Col.splice(TargetColIdx + 1, 0, BlockMappingConfig);
			}else{
				RowMapping.Col.push(BlockMappingConfig);
			}
		}else{
			RowMapping.Col.push(BlockMappingConfig);
		}
	}else if(OptionConfig.TargetAddType != null){
		if(OptionConfig.TargetAddType == "Before"){
			RowMapping.Col.splice(0, 0, BlockMappingConfig);
		}else if(OptionConfig.TargetAddType == "After"){
			RowMapping.Col.push(BlockMappingConfig);
		}else{
			RowMapping.Col.push(BlockMappingConfig);
		}
	}else{
		RowMapping.Col.push(BlockMappingConfig);
	}
	
	let ColLength = 12 / RowMapping.Col.length;
	RowMapping.Col.map((Obj,Idx) => {
		Editor.Obj[Obj.Id].Properties.Length = ColLength;
	})
	
	return GenId;
}

window.EDMAddContent = function(EditorId,EDMColId,BlockData = {},OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentCol = Editor.Obj[EDMColId];
	if(!CurrentCol || CurrentCol.Type != 'Col') { console.error("column not found"); return; };
	
	if(BlockData.Type !=  null){
		let ConfigKeys = Object.keys(Editor.Obj)
		for(let F = 0;F < ConfigKeys.length;F++){
			let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
			if(BlockContentConfig.Type == "Content" && BlockContentConfig.ColId == EDMColId){
				delete Editor.Obj[ConfigKeys[F]]
				break;
			}
		}
		
		let GenId = EDMGetRandomId();
		
		while(Editor[GenId] != null){
			GenId = EDMGetRandomId();
		}

		let BlockConfig = {
			Id:GenId,
			Type:"Content",
			ColId:CurrentCol.Id,
			Properties:{
				Content:{
					Type:BlockData.Type || 'blank',
					Properties:BlockData.Properties || {},
				}
			},
		}
	
		if(OptionConfig.Properties != null){
			let ConfigKeys = Object.keys(OptionConfig.Properties)
			for(let F = 0;F < ConfigKeys.length;F++){
				BlockConfig.Properties[ConfigKeys[F]] = OptionConfig.Properties[ConfigKeys[F]];
			}
		}
		
		Editor.Obj[GenId] = BlockConfig;
	
		return GenId;
	}
	return null;
}

window.EDMRemoveRow = function(EditorId,EDMRowId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	if(TargetRowIdx != -1){
		Editor.ObjMapping[TargetRowIdx].Col.map((Obj,Idx)=>{
			let ConfigKeys = Object.keys(Editor.Obj)
			for(let F = 0;F < ConfigKeys.length;F++){
				let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
				if(BlockContentConfig.Type == "Content" && BlockContentConfig.ColId == Obj.Id){
					delete Editor.Obj[BlockContentConfig.Id];
				}
			}
			delete Editor.Obj[Obj.Id];
		})
		
		Editor.ObjMapping.splice(TargetRowIdx, 1);
		delete Editor.Obj[EDMRowId];
	}
}

window.EDMRemoveCol = function(EditorId,EDMRowId,EDMColId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	let CurrentCol = Editor.Obj[EDMColId];
	if(!CurrentCol || CurrentCol.Type != 'Col') { console.error("column not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	let RowMapping = Editor.ObjMapping[TargetRowIdx];
	
	if(TargetRowIdx != -1){
		let TargetColIdx = -1
		RowMapping.Col.map((Obj,Idx) => {
			if(Obj.Id === EDMColId) TargetColIdx = Idx;
		})
	
		let ConfigKeys = Object.keys(Editor.Obj)
		for(let F = 0;F < ConfigKeys.length;F++){
			let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
			if(BlockContentConfig.Type == "Content" && BlockContentConfig.ColId == EDMColId){
				delete Editor.Obj[BlockContentConfig.Id];
			}
		}
		
		if(TargetColIdx != -1){
			RowMapping.Col.splice(TargetColIdx, 1);
			delete Editor.Obj[EDMColId];
		}
	}
	
	let ColLength = 12 / RowMapping.Col.length;
	RowMapping.Col.map((Obj,Idx) => {
		Editor.Obj[Obj.Id].Properties.Length = ColLength;
	})
}

window.EDMRemoveContent = function(EditorId,EDMContentId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentContent = Editor.Obj[EDMContentId];
	if(!CurrentContent || CurrentContent.Type != 'Content') { console.error("content not found"); return; };
	
	delete Editor.Obj[EDMContentId];
}

window.EDMMoveRow = function(EditorId,EDMRowId,EDMMoveToRowId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	let CurrentMoveRow = Editor.Obj[EDMMoveToRowId];
	if(!CurrentMoveRow || CurrentMoveRow.Type != 'Row') { console.error("move to row not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	
	if(TargetRowIdx != -1){
		let BlockMappingConfig = JSON.parse(JSON.stringify(Editor.ObjMapping[TargetRowIdx]));
		Editor.ObjMapping.splice(TargetRowIdx, 1);
		
		let TargetRowMoveToIdx = -1
		Editor.ObjMapping.map((Obj,Idx) => {
			if(Obj.Id === EDMMoveToRowId) TargetRowMoveToIdx = Idx;
		})
		
		if(TargetRowMoveToIdx != -1){
			if(OptionConfig.TargetAddType == "Before"){
				Editor.ObjMapping.splice(TargetRowMoveToIdx, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				Editor.ObjMapping.splice(TargetRowMoveToIdx + 1, 0, BlockMappingConfig);
			}else{
				Editor.ObjMapping.splice(TargetRowMoveToIdx, 0, BlockMappingConfig);
			}
		}else{
			Editor.ObjMapping.splice(TargetRowIdx, 0, BlockMappingConfig);
		}
	}
}

window.EDMMoveCol = function(EditorId,EDMRowId,EDMColId,EDMMoveToColId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	let CurrentCol = Editor.Obj[EDMColId];
	if(!CurrentCol || CurrentCol.Type != 'Col') { console.error("column not found"); return; };
	let CurrentMoveCol = Editor.Obj[EDMMoveToColId];
	if(!CurrentMoveCol || CurrentMoveCol.Type != 'Col') { console.error("move to column not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	let RowMapping = Editor.ObjMapping[TargetRowIdx];
	
	let TargetColIdx = -1
	RowMapping.Col.map((Obj,Idx) => {
		if(Obj.Id === EDMColId) TargetColIdx = Idx;
	})
		
	if(TargetColIdx != -1){
		let BlockMappingConfig = JSON.parse(JSON.stringify(RowMapping.Col[TargetColIdx]));
		RowMapping.Col.splice(TargetColIdx, 1);
		
		let TargetColMoveToIdx = -1
		RowMapping.Col.map((Obj,Idx) => {
			if(Obj.Id === EDMMoveToColId) TargetColMoveToIdx = Idx;
		})
		
		if(TargetColMoveToIdx != -1){
			if(OptionConfig.TargetAddType == "Before"){
				RowMapping.Col.splice(TargetColMoveToIdx, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				RowMapping.Col.splice(TargetColMoveToIdx + 1, 0, BlockMappingConfig);
			}else{
				RowMapping.Col.splice(TargetColMoveToIdx, 0, BlockMappingConfig);
			}
		}else{
			RowMapping.Col.splice(TargetColIdx, 0, BlockMappingConfig);
		}
	}
}

window.EDMMoveContent = function(EditorId,EDMContentId,EDMMoveToColId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentContent = Editor.Obj[EDMContentId];
	if(!CurrentContent || CurrentContent.Type != 'Content') { console.error("content not found"); return; };
	let CurrentMoveCol = Editor.Obj[EDMMoveToColId];
	if(!CurrentMoveCol || CurrentMoveCol.Type != 'Col') { console.error("move to column not found"); return; };
	
	CurrentContent.ColId = CurrentMoveCol.Id;
}

window.EDMSwapContent = function(EditorId,EDMContentId,EDMSwapContentId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentContent = Editor.Obj[EDMContentId];
	if(!CurrentContent || CurrentContent.Type != 'Content') { console.error("content not found"); return; };
	let CurrentSwapContent = Editor.Obj[EDMSwapContentId];
	if(!CurrentSwapContent || CurrentSwapContent.Type != 'Content') { console.error("swap content not found"); return; };
	
	let CurrentContentColId = CurrentContent.ColId;
	let CurrentSwapContentColId = CurrentSwapContent.ColId;
	CurrentContent.ColId = CurrentSwapContentColId;
	CurrentSwapContent.ColId = CurrentContentColId;
}

window.EDMDuplicateRow = function(EditorId,EDMRowId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	
	let CurrentRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) CurrentRowIdx = Idx;
	})
	let RowMapping = Editor.ObjMapping[CurrentRowIdx];
	
	let GenId = EDMGetRandomId();
	
	while(Editor[GenId] != null){
		GenId = EDMGetRandomId();
	}
	
	let BlockConfig = JSON.parse(JSON.stringify(CurrentRow));
	BlockConfig.Id = GenId;
	
	Editor.Obj[GenId] = BlockConfig;
	
	let BlockMappingConfig = {
		Id:GenId,
		Col:[],
	}
	
	if(OptionConfig.TargetObjId != null){
		let TargetRowIdx = -1
		Editor.ObjMapping.map((Obj,Idx) => {
			if(Obj.Id === OptionConfig.TargetObjId) TargetRowIdx = Idx;
		})
		if(TargetRowIdx != -1){
			if(OptionConfig.TargetAddType == "Before"){
				Editor.ObjMapping.splice(TargetRowIdx, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				Editor.ObjMapping.splice(TargetRowIdx + 1, 0, BlockMappingConfig);
			}else{
				Editor.ObjMapping.push(BlockMappingConfig);
			}
		}else{
			Editor.ObjMapping.push(BlockMappingConfig);
		}
	}else if(OptionConfig.TargetAddType != null){
		if(OptionConfig.TargetAddType == "Before"){
			Editor.ObjMapping.splice(0, 0, BlockMappingConfig);
		}else if(OptionConfig.TargetAddType == "After"){
			Editor.ObjMapping.push(BlockMappingConfig);
		}else{
			Editor.ObjMapping.push(BlockMappingConfig);
		}
	}else{
		Editor.ObjMapping.push(BlockMappingConfig);
	}
	
	RowMapping.Col.map((Obj,Idx) => {
		EDMDuplicateColToRow(EditorId,RowMapping.Id,Obj.Id,GenId,OptionConfig.SubConfig || {});
	})
	
	return GenId;
}

window.EDMDuplicateCol = function(EditorId,EDMRowId,EDMColId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	let CurrentCol = Editor.Obj[EDMColId];
	if(!CurrentCol || CurrentCol.Type != 'Col') { console.error("column not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	let RowMapping = Editor.ObjMapping[TargetRowIdx];
	
	let TargetColIdx = -1
	RowMapping.Col.map((Obj,Idx) => {
		if(Obj.Id === EDMColId) TargetColIdx = Idx;
	})
		
	if(TargetColIdx != -1){
		let GenId = EDMGetRandomId();
	
		while(Editor[GenId] != null){
			GenId = EDMGetRandomId();
		}
		
		let BlockConfig = JSON.parse(JSON.stringify(CurrentCol));
		BlockConfig.Id = GenId;
		
		if(OptionConfig.Properties != null){
			let ConfigKeys = Object.keys(OptionConfig.Properties)
			for(let F = 0;F < ConfigKeys.length;F++){
				BlockConfig.Properties[ConfigKeys[F]] = OptionConfig.Properties[ConfigKeys[F]];
			}
		}
		
		Editor.Obj[GenId] = BlockConfig;
		
		let BlockMappingConfig = {
			Id:GenId,
		}
		
		if(OptionConfig.TargetObjId != null){
			let TargetColIdx = -1
			RowMapping.Col.map((Obj,Idx) => {
				if(Obj.Id === OptionConfig.TargetObjId) TargetColIdx = Idx;
			})
			if(TargetColIdx != -1){
				if(OptionConfig.TargetAddType == "Before"){
					RowMapping.Col.splice(TargetColIdx, 0, BlockMappingConfig);
				}else if(OptionConfig.TargetAddType == "After"){
					RowMapping.Col.splice(TargetColIdx + 1, 0, BlockMappingConfig);
				}else{
					RowMapping.Col.push(BlockMappingConfig);
				}
			}else{
				RowMapping.Col.push(BlockMappingConfig);
			}
		}else if(OptionConfig.TargetAddType != null){
			if(OptionConfig.TargetAddType == "Before"){
				RowMapping.Col.splice(0, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				RowMapping.Col.push(BlockMappingConfig);
			}else{
				RowMapping.Col.push(BlockMappingConfig);
			}
		}else{
			RowMapping.Col.push(BlockMappingConfig);
		}
		
		let ColLength = 12 / RowMapping.Col.length;
		RowMapping.Col.map((Obj,Idx) => {
			Editor.Obj[Obj.Id].Properties.Length = ColLength;
		})
		
		let BlockContentList = {}
		
		let ConfigKeys = Object.keys(Editor.Obj)
		for(let F = 0;F < ConfigKeys.length;F++){
			let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
			if(BlockContentConfig.Type == "Content"){
				BlockContentList[BlockContentConfig.ColId] = BlockContentConfig
			}
		}
		
		let OldContentConfig = BlockContentList[CurrentCol.Id];
		if (OldContentConfig != null){
			EDMDuplicateContent(EditorId,OldContentConfig.Id,GenId,OptionConfig.SubConfig || {});
		}
		
		return GenId;
	}
	
	return null;
}

window.EDMDuplicateColToRow = function(EditorId,EDMRowId,EDMColId,EDMToRowId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentRow = Editor.Obj[EDMRowId];
	if(!CurrentRow || CurrentRow.Type != 'Row') { console.error("row not found"); return; };
	let CurrentCol = Editor.Obj[EDMColId];
	if(!CurrentCol || CurrentCol.Type != 'Col') { console.error("column not found"); return; };
	let CurrentToRow = Editor.Obj[EDMToRowId];
	if(!CurrentToRow || CurrentToRow.Type != 'Row') { console.error("to row not found"); return; };
	
	let TargetRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMRowId) TargetRowIdx = Idx;
	})
	let RowMapping = Editor.ObjMapping[TargetRowIdx];
	
	let TargetColIdx = -1
	RowMapping.Col.map((Obj,Idx) => {
		if(Obj.Id === EDMColId) TargetColIdx = Idx;
	})
	
	let TargetToRowIdx = -1
	Editor.ObjMapping.map((Obj,Idx) => {
		if(Obj.Id === EDMToRowId) TargetToRowIdx = Idx;
	})
	let ToRowMapping = Editor.ObjMapping[TargetToRowIdx];
		
	if(TargetColIdx != -1 && TargetToRowIdx != -1){
		let GenId = EDMGetRandomId();
	
		while(Editor[GenId] != null){
			GenId = EDMGetRandomId();
		}
		
		let BlockConfig = JSON.parse(JSON.stringify(CurrentCol));
		BlockConfig.Id = GenId;
		
		if(OptionConfig.Properties != null){
			let ConfigKeys = Object.keys(OptionConfig.Properties)
			for(let F = 0;F < ConfigKeys.length;F++){
				BlockConfig.Properties[ConfigKeys[F]] = OptionConfig.Properties[ConfigKeys[F]];
			}
		}
		
		Editor.Obj[GenId] = BlockConfig;
		
		let BlockMappingConfig = {
			Id:GenId,
		}
		
		if(OptionConfig.TargetObjId != null){
			let TargetColIdx = -1
			ToRowMapping.Col.map((Obj,Idx) => {
				if(Obj.Id === OptionConfig.TargetObjId) TargetColIdx = Idx;
			})
			if(TargetColIdx != -1){
				if(OptionConfig.TargetAddType == "Before"){
					ToRowMapping.Col.splice(TargetColIdx, 0, BlockMappingConfig);
				}else if(OptionConfig.TargetAddType == "After"){
					ToRowMapping.Col.splice(TargetColIdx + 1, 0, BlockMappingConfig);
				}else{
					ToRowMapping.Col.push(BlockMappingConfig);
				}
			}else{
				ToRowMapping.Col.push(BlockMappingConfig);
			}
		}else if(OptionConfig.TargetAddType != null){
			if(OptionConfig.TargetAddType == "Before"){
				ToRowMapping.Col.splice(0, 0, BlockMappingConfig);
			}else if(OptionConfig.TargetAddType == "After"){
				ToRowMapping.Col.push(BlockMappingConfig);
			}else{
				ToRowMapping.Col.push(BlockMappingConfig);
			}
		}else{
			ToRowMapping.Col.push(BlockMappingConfig);
		}
		
		let BlockContentList = {}
		
		let ConfigKeys = Object.keys(Editor.Obj)
		for(let F = 0;F < ConfigKeys.length;F++){
			let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
			if(BlockContentConfig.Type == "Content"){
				BlockContentList[BlockContentConfig.ColId] = BlockContentConfig
			}
		}
		
		let OldContentConfig = BlockContentList[CurrentCol.Id];
		if (OldContentConfig != null){
			EDMDuplicateContent(EditorId,OldContentConfig.Id,GenId,OptionConfig.SubConfig || {});
		}
		
		return GenId;
	}
	
	return null;
}

window.EDMDuplicateContent = function(EditorId,EDMContentId,EDMDupToColId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentContent = Editor.Obj[EDMContentId];
	if(!CurrentContent || CurrentContent.Type != 'Content') { console.error("content not found"); return; };
	let CurrentDupCol = Editor.Obj[EDMDupToColId];
	if(!CurrentDupCol || CurrentDupCol.Type != 'Col') { console.error("duplicate to column not found"); return; };
	
	let ConfigKeys = Object.keys(Editor.Obj)
	for(let F = 0;F < ConfigKeys.length;F++){
		let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
		if(BlockContentConfig.Type == "Content" && BlockContentConfig.ColId == CurrentDupCol.Id){
			console.error("column already used"); return;
		}
	}
	
	let GenId = EDMGetRandomId();
	
	while(Editor[GenId] != null){
		GenId = EDMGetRandomId();
	}
	
	let DuplicateCurrentContent = JSON.parse(JSON.stringify(CurrentContent));
	DuplicateCurrentContent.Id = GenId;
	DuplicateCurrentContent.ColId = CurrentDupCol.Id;
	
	Editor.Obj[GenId] = DuplicateCurrentContent;
	
	return GenId;
}

window.EDMDuplicateContentAndReplace = function(EditorId,EDMContentId,EDMReplaceContentId,OptionConfig = {}){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let CurrentContent = Editor.Obj[EDMContentId];
	if(!CurrentContent || CurrentContent.Type != 'Content') { console.error("content not found"); return; };
	let CurrentReplaceContent = Editor.Obj[EDMReplaceContentId];
	if(!CurrentReplaceContent || CurrentReplaceContent.Type != 'Content') { console.error("replace to content not found"); return; };
	
	let GenId = EDMGetRandomId();
	
	while(Editor[GenId] != null){
		GenId = EDMGetRandomId();
	}
	
	let DuplicateCurrentContent = JSON.parse(JSON.stringify(CurrentContent));
	DuplicateCurrentContent.Id = GenId;
	DuplicateCurrentContent.ColId = CurrentReplaceContent.ColId;
	
	Editor.Obj[GenId] = DuplicateCurrentContent;
		
	delete Editor.Obj[CurrentReplaceContent.Id];
	
	return GenId;
}

window.EDMRender = function(EditorId){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let DocumentScroll = document.scrollTop;
	let EditorScroll = EditorRT.ScrollTop;
	EDMClearEvent(EditorId);
	EditorRT.BaseEditorDom.innerHTML = "";
	EDMGenerateStyle(EditorRT.BaseDom,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.AreaManagementStyle,...Editor.Properties.BaseLayout.Style}));
	EDMGenerateStyle(EditorRT.BaseEditorDom,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.AreaManagementFrameStyle));
	
	let ElementEventFunction = (ObjectData,Event) => {
		let ConfigKeys = [];
		switch(Event.type){
			case 'click':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Click)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.Click[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'mouseup':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Up)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.Up[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'mousedown':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Down)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.Down[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'mousemove':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Hover)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.Hover[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'drag':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drag)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.Drag[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'dragstart':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragStart)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.DragStart[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'dragend':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnd)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.DragEnd[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'dragover':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragOver)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.DragOver[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'dragenter':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnter)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.DragEnter[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'dragleave':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragLeave)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.DragLeave[ConfigKeys[F]](ObjectData,Event);
				}
			break;
			case 'drop':
				ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drop)
				for(let F = 0;F < ConfigKeys.length;F++){
					EditorRT.Config.EventFunction.Drop[ConfigKeys[F]](ObjectData,Event);
				}
			break;
		}
	}
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'click',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'mouseup',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'mousedown',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'mousemove',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'drag',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'dragstart',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'dragend',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'dragover',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'dragenter',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'dragleave',ElementEventFunction);
	EDMAddEvent(EditorRT.Id,EditorRT.Dom,'drop',ElementEventFunction);
	
	Editor.ObjMapping.map((Block) => {
		let BlockRowConfig = Editor.Obj[Block.Id];
		let BlockElement = EDMGenerateRender(EditorRT,BlockRowConfig);
		let BlockContentList = {}
		
		let ConfigKeys = Object.keys(Editor.Obj)
		for(let F = 0;F < ConfigKeys.length;F++){
			let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
			if(BlockContentConfig.Type == "Content"){
				BlockContentList[BlockContentConfig.ColId] = BlockContentConfig
			}
		}
		
		if(Block.Col && Block.Col.length > 0){
			let BlockElementRow = BlockElement.querySelector('td tr');
			Block.Col.map((BlockColMappingConfig)=>{
				let BlockColConfig = Editor.Obj[BlockColMappingConfig.Id];
				let BlockElementCol = EDMGenerateRender(EditorRT,BlockColConfig);
				let BlockElementContent = BlockContentList[BlockColConfig.Id];
				if(BlockElementContent != null){
					BlockElementCol.querySelector('span.edm-editor-col-data').appendChild(EDMGenerateRender(EditorRT,BlockElementContent));
				}
				BlockElementRow.appendChild(BlockElementCol);
			});
		}
		
		EditorRT.BaseEditorDom.appendChild(BlockElement)
	})
	
	document.scrollTop = DocumentScroll;
	EditorRT.Dom.scrollTop = EditorScroll;
}

window.EDMRenderValidate = function(EditorId){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let ValidateResult = true;
	
	EditorRT.BaseEditorDom.querySelectorAll('.edm-editor-row-selector>table>tbody>tr>td>table').forEach((ElementTable) => {
		if(ElementTable.clientWidth > EditorRT.Config.FixContentAreaSize ) ValidateResult = false
	})
	return ValidateResult;
}

window.EDMRenderLoad = function(EditorId,JSONData){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	EDMEditor[EditorId] = {...Editor,...JSON.parse(JSONData)};
}

window.EDMRenderSave = function(EditorId){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	return JSON.stringify({
		Obj:Editor.Obj,
		ObjMapping:Editor.ObjMapping,
		Properties:Editor.Properties,
	})
}

window.EDMRenderResult = function(EditorId){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let ElementHTML = document.createElement("html");
	ElementHTML.setAttribute('xmlns','http://www.w3.org/1999/xhtml');
	let ElementHead = document.createElement("head");
	ElementHead.setAttribute('xmlns:v','urn:schemas-microsoft-com:vml');
	ElementHTML.appendChild(ElementHead);
	
	let ElementStyle = document.createElement("style");
	ElementStyle.type = 'text/css';
	let ElementStyleData = '';
	ElementStyleData = ElementStyleData + '[class~="x_non-support-video"]{ display: none !important; }';

	ElementStyle.innerHTML = ElementStyleData;
	ElementHead.appendChild(ElementStyle);
	
	let ElementBody = document.createElement("body");
	ElementBody.setAttribute('topmargin','0');
	ElementBody.setAttribute('bottommargin','0');
	ElementBody.setAttribute('leftmargin','0');
	ElementBody.setAttribute('rightmargin','0');
	ElementBody.setAttribute('marginheight','0');
	ElementBody.setAttribute('marginwidth','0');
	EDMGenerateStyle(ElementBody,{...{['margin']:'0',['padding']:'0'}});
	ElementHTML.appendChild(ElementBody);
	
	let ElementTableBase = document.createElement("table");
	EDMGenerateStyle(ElementTableBase,{...{['margin']:'0',['padding']:'0'},...EditorRT.Config.AreaManagementStyle,...Editor.Properties.BaseLayout.Style});
	ElementBody.appendChild(ElementTableBase);
	
	let ElementTableBaseBody = document.createElement("tbody");
	let ElementTableBaseRow = document.createElement("tr");
	let ElementTableBaseData = document.createElement("td");
	EDMGenerateClass(ElementTableBaseData,EditorRT.Config.GlobalClass['td']);
	EDMGenerateAttribute(ElementTableBaseData,{...{['align']:'center',['valign']:'top'},...EditorRT.Config.GlobalAttribute['td']});
	EDMGenerateStyle(ElementTableBaseData,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['td']));
	ElementTableBase.appendChild(ElementTableBaseBody);
	ElementTableBaseBody.appendChild(ElementTableBaseRow);
	ElementTableBaseRow.appendChild(ElementTableBaseData);
	let ElementTable = document.createElement("table");
	EDMGenerateClass(ElementTable,EditorRT.Config.GlobalClass['table']);
	EDMGenerateAttribute(ElementTable,EditorRT.Config.GlobalAttribute['table']);
	EDMGenerateStyle(ElementTable,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.AreaManagementFrameStyle}));
	let ElementTableBody = document.createElement("tbody");
	let ElementTableRow = document.createElement("tr");
	let ElementTableData = document.createElement("td");
	EDMGenerateClass(ElementTableData,EditorRT.Config.GlobalClass['td']);
	EDMGenerateAttribute(ElementTableData,EDMGenerateAttribute(ElementTableBaseData,{...{['align']:'center'},...EditorRT.Config.GlobalAttribute['td']}));
	EDMGenerateStyle(ElementTableData,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['td']));
	ElementTableBaseData.appendChild(ElementTable);
	ElementTable.appendChild(ElementTableBody);
	ElementTableBody.appendChild(ElementTableRow);
	ElementTableRow.appendChild(ElementTableData);
	
	let ElementCenter = document.createElement("center");
	ElementTableData.appendChild(ElementCenter);
	
	Editor.ObjMapping.map((Block) => {
		let BlockRowConfig = JSON.parse(JSON.stringify(Editor.Obj[Block.Id]));
		BlockRowConfig.Type = 'RowRaw';
		let BlockElement = EDMGenerateRender(EditorRT,BlockRowConfig);
		let BlockContentList = {}
		
		let ConfigKeys = Object.keys(Editor.Obj)
		for(let F = 0;F < ConfigKeys.length;F++){
			let BlockContentConfig = Editor.Obj[ConfigKeys[F]];
			if(BlockContentConfig.Type == "Content"){
				BlockContentList[BlockContentConfig.ColId] = BlockContentConfig
			}
		}
		
		if(Block.Col && Block.Col.length > 0){
			let BlockElementRow = BlockElement.querySelector('td tr');
			Block.Col.map((BlockColMappingConfig)=>{
				let BlockColConfig = JSON.parse(JSON.stringify(Editor.Obj[BlockColMappingConfig.Id]));
				BlockColConfig.Type = 'ColRaw';
				let BlockElementCol = EDMGenerateRender(EditorRT,BlockColConfig);
				let BlockElementContent = BlockContentList[BlockColConfig.Id];
				if(BlockElementContent != null){
					BlockElementContent = JSON.parse(JSON.stringify(BlockElementContent))
					BlockElementContent.Type = 'ContentRaw';
					BlockElementCol.appendChild(EDMGenerateRender(EditorRT,BlockElementContent));
				}
				BlockElementRow.appendChild(BlockElementCol);
			});
		}
		
		ElementCenter.appendChild(BlockElement)
	})
	
	let ElementFixSizeTable = document.createElement("table");
	EDMGenerateClass(ElementFixSizeTable,[...EditorRT.Config.GlobalClass['table'],...EditorRT.Config.DefaultClass['table']]);
	EDMGenerateAttribute(ElementFixSizeTable,{...EditorRT.Config.GlobalAttribute['table'],...EditorRT.Config.DefaultAttribute['table']});
	EDMGenerateStyle(ElementFixSizeTable,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.GlobalStyle['table'],...EditorRT.Config.DefaultStyle['table']}));
	let ElementFixSizeTableBody = document.createElement("tbody");
	let ElementFixSizeTableRow = document.createElement("tr");
	let ElementFixSizeTableData = document.createElement("td");
	EDMGenerateClass(ElementFixSizeTableData,EditorRT.Config.GlobalClass['td']);
	EDMGenerateAttribute(ElementFixSizeTableData,EditorRT.Config.GlobalAttribute['td']);
	EDMGenerateStyle(ElementFixSizeTableData,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['td']));
	ElementFixSizeTable.appendChild(ElementFixSizeTableBody);
	ElementFixSizeTableBody.appendChild(ElementFixSizeTableRow);
	ElementFixSizeTableRow.appendChild(ElementFixSizeTableData);
	let ElementFixSizeTableContent = document.createElement("table");
	EDMGenerateClass(ElementFixSizeTableContent,EditorRT.Config.GlobalClass['table']);
	EDMGenerateAttribute(ElementFixSizeTableContent,EditorRT.Config.GlobalAttribute['table']);
	EDMGenerateStyle(ElementFixSizeTableContent,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['table']));
	let ElementFixSizeTableContentBody = document.createElement("tbody");
	let ElementFixSizeTableContentRow = document.createElement("tr");
	let ElementFixSizeTableContentData = document.createElement("td");
	EDMGenerateClass(ElementFixSizeTableContentData,EditorRT.Config.GlobalClass['td']);
	EDMGenerateAttribute(ElementFixSizeTableContentData,EDMGenerateAttribute(ElementTableBaseData,{...{['align']:'center'},...EditorRT.Config.GlobalAttribute['td']}));
	EDMGenerateStyle(ElementFixSizeTableContentData,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['td']));
	ElementFixSizeTableData.appendChild(ElementFixSizeTableContent);
	ElementFixSizeTableContent.appendChild(ElementFixSizeTableContentBody);
	ElementFixSizeTableContentBody.appendChild(ElementFixSizeTableContentRow);
	ElementFixSizeTableContentRow.appendChild(ElementFixSizeTableContentData);
	
	let ElementRenderAreaFixSize = document.createElement("img");
	EDMGenerateAttribute(ElementRenderAreaFixSize,{['alt']:'image',['src']:'https://lh3.googleusercontent.com/W-DRyfapZZsC5nofb9iql6QVvmphXfY9G0P8alTlZ9VqiqjO9sGot-GoqZm61YMXTewyf9txHgdAYd_2CmjzJhg7Qm89MCKdgJujUl2UHLW-XI0p8Io4JK-MaaLhmp66EvgKa1KFlA=w' + (EditorRT.Config.FixContentAreaSize ? Math.max(1,EditorRT.Config.FixContentAreaSize) : 1) + '-h1-no'});
	EDMGenerateStyle(ElementRenderAreaFixSize,{['vertical-align']:'top',['display']:'block'});
	
	ElementFixSizeTableContentData.appendChild(ElementRenderAreaFixSize);
	
	if(Editor.Properties.AfterContentHtml != null && Editor.Properties.AfterContentHtml != ''){
		ElementBody.insertAdjacentHTML('beforeend',Editor.Properties.AfterContentHtml);
	}
	
	ElementCenter.appendChild(ElementFixSizeTable);
	return ElementHTML.outerHTML;
}

var EDMAddEvent = function(EditorId,EventElementObject,EventType,EventFunction){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let EventFunctionAttach = function(Event){
		if(EditorRT.Config.EditMode == 'readonly'){
			Event.preventDefault();
			return;
		}
		if(EventFunction != null){
			let ReturnObject = {
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option: {
					RowSide:'Default',
					ColSide:'Default',
					MouseX:Event.x,
					MouseY:Event.y,
				},
			}
			let DefaultObject = {
				Type: 'None',
				Id: null,
				Obj: null,
				ColId: null,
				ColObj: null,
				RowId: null,
				RowObj: null,
				Option: {
					RowSide:'Default',
					ColSide:'Default',
					MouseX:Event.x,
					MouseY:Event.y,
				},
			}
			let TargetObject = Editor.Obj[Event.currentTarget.getAttribute('id')];
			let TargetElementColObject = null;
			let TargetElementRowObject = null;
			if(TargetObject != null){
				ReturnObject.Type = TargetObject.Type
				ReturnObject.Id = TargetObject.Id;
				ReturnObject.Obj = TargetObject;
				switch(TargetObject.Type){
					case 'Row':
					TargetElementRowObject = Event.currentTarget;
					ReturnObject.RowId = TargetObject.Id;
					ReturnObject.RowObj = TargetObject;
					break;
					case 'Col':
					TargetElementColObject = Event.currentTarget;
					ReturnObject.ColId = TargetObject.Id;
					ReturnObject.ColObj = TargetObject;
					let RowObject = Event.currentTarget.closest('.edm-editor-row-selector');
					if(RowObject != null){
						TargetElementRowObject = RowObject;
						TargetObject = Editor.Obj[TargetElementRowObject.getAttribute('id')];
						ReturnObject.RowId = TargetObject.Id;
						ReturnObject.RowObj = TargetObject;
					}
					break;
					case 'Content':
					let ColObject = Event.target.closest('.edm-editor-col-selector');
					if(ColObject != null) ColObject = ColObject.querySelector('.edm-editor-col-selector-ui');
					if(ColObject != null){
						TargetElementColObject = ColObject;
						TargetObject = Editor.Obj[TargetElementColObject.getAttribute('id')];
						ReturnObject.ColId = TargetObject.Id;
						ReturnObject.ColObj = TargetObject;
						let ColRowObject = TargetElementColObject.closest('.edm-editor-row-selector');
						if(ColRowObject != null){
							TargetElementRowObject = ColRowObject;
							TargetObject = Editor.Obj[ColRowObject.getAttribute('id')];
							ReturnObject.RowId = TargetObject.Id;
							ReturnObject.RowObj = TargetObject;
						}
					}
					break;
				}
			}
			
			if(TargetElementRowObject != null){
				let Center = EDMGetObjectOffset(TargetElementRowObject).top + (TargetElementRowObject.clientHeight / 2);
				ReturnObject.Option.RowSide = Event.y > Center ? 'After' : 'Before';
			}
			
			if(TargetElementColObject != null){
				let Center = EDMGetObjectOffset(TargetElementColObject).left + (TargetElementColObject.clientWidth / 2);
				ReturnObject.Option.ColSide = Event.x > Center ? 'After' : 'Before';
			}
			
			if(EditorRT.EventAction[Event.type] == null) EditorRT.EventAction[Event.type] = true;
			
			if(EditorRT.EventAction[Event.type] == true){
				EditorRT.EventAction[Event.type] = false;
				switch(Event.type){
					case 'click':
						if(EditorRT.MouseClickAction == true){
							EditorRT.Properties.SelectObject = ReturnObject;
						}
					break;
					case 'mouseup':
						EditorRT.MouseClickAction = true;
						EditorRT.Properties.MouseUpObject = ReturnObject;
					break;
					case 'mousedown':
						EditorRT.MouseClickAction = true;
						EditorRT.Properties.MouseDownObject = ReturnObject;
					break;
					case 'mousemove':
						if(EditorRT.MouseClickAction == true){
							EditorRT.MouseClickAction = false;
						}
						EditorRT.Properties.MouseHoverObject = ReturnObject;
					break;
					case 'drag':
						if(EditorRT.MouseClickAction == true){
							EditorRT.MouseClickAction = false;
						}
						EditorRT.Properties.MouseDragObject = ReturnObject;
					break;
					case 'dragstart':
						if(EditorRT.MouseClickAction == true){
							EditorRT.MouseClickAction = false;
						}
						EditorRT.Properties.MouseDragStartObject = ReturnObject;
					break;
					case 'dragend':
						EditorRT.Properties.MouseDragEndObject = ReturnObject;
					break;
					case 'dragover':
						if(EditorRT.MouseClickAction == true){
							EditorRT.MouseClickAction = false;
						}
						EditorRT.Properties.MouseDragOverObject = ReturnObject;
						Event.preventDefault();
					break;
					case 'dragenter':
						EditorRT.Properties.MouseDragEnterObject = ReturnObject;
						Event.preventDefault();
					break;
					case 'dragleave':
						EditorRT.Properties.MouseDragLeaveObject = ReturnObject;
					break;
					case 'drop':
						EditorRT.Properties.MouseDropObject = ReturnObject;
					break;
				}
				EventFunction(ReturnObject,Event);
			}
			
			if(ReturnObject.Type == 'None') EditorRT.EventAction[Event.type] = true;
		}
	}
	
	EventElementObject.addEventListener(EventType,EventFunctionAttach);
	EditorRT.Event.push({
		Obj:EventElementObject,
		Type:EventType,
		Function:EventFunctionAttach
	});
}

var EDMClearEvent = function(EditorId){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	EditorRT.Event.map((EventObj)=>{
		EventObj.Obj.removeEventListener(EventObj.Type,EventObj.Function);
	});
}

var EDMAddScrollEvent = function(EditorId,EventElementObject,EventFunction){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	let EventFunctionAttach = function(Event){
		if(EventFunction != null){
			EventFunction(Event);
		}
	}
	
	EventElementObject.addEventListener('scroll',EventFunctionAttach);
	EditorRT.ScrollEvent.push({
		Obj:EventElementObject,
		Function:EventFunctionAttach
	});
}

var EDMClearScrollEvent = function(EditorId){
	let Editor = EDMEditor[EditorId];
	let EditorRT = EDMEditorRuntime[EditorId];
	if(!Editor) { console.error("editor not found"); return; };
	
	EditorRT.ScrollEvent.map((EventObj)=>{
		EventObj.Obj.removeEventListener('scroll',EventObj.Function);
	});
}

var EDMGenerateClass = function(ElementObject,Config){
	Config.map((ClassData)=>{
		ElementObject.classList.add(ClassData);
	})
	return ElementObject;
}

var EDMGenerateAttribute = function(ElementObject,Config){
	let ConfigKeys = Object.keys(Config)
	for(let F = 0;F < ConfigKeys.length;F++){
		ElementObject.setAttribute(ConfigKeys[F],Config[ConfigKeys[F]]);
	}
	return ElementObject;
}

var EDMGenerateStyle = function(ElementObject,Config){
	let StyleRender = '';
	let ConfigKeys = Object.keys(Config)
	for(let F = 0;F < ConfigKeys.length;F++){
		StyleRender += ConfigKeys[F] + ':' + Config[ConfigKeys[F]] + ';';
	}
	if(StyleRender != ''){
		ElementObject.setAttribute('style',StyleRender);
	}
	return ElementObject;
}

var EDMGenerateStyleString = function(Config){
	let StyleRender = '';
	let ConfigKeys = Object.keys(Config)
	for(let F = 0;F < ConfigKeys.length;F++){
		StyleRender += ConfigKeys[F] + ':' + Config[ConfigKeys[F]] + ';';
	}
	return StyleRender;
}

var EDMGenerateTypeRuleCheck = function(FilterOut,Config){
	let RenderConfig = JSON.parse(JSON.stringify(Config));
	FilterOut.map((FilterKey) => {
		delete RenderConfig[FilterKey];
	})
	return RenderConfig;
}

var EDMGenerateRender = function(EditorRT,BlockConfig) {
	let ElementObject = null;
	switch(BlockConfig.Type){
		case 'Row':
		ElementObject = document.createElement("div");
		ElementObject.setAttribute("id",BlockConfig.Id);
		EDMGenerateClass(ElementObject,[...EditorRT.Config.UIRowEventClass,...["edm-editor-row-selector"]]);
		EDMGenerateAttribute(ElementObject,EditorRT.Config.UIRowEventAttribute);
		EDMGenerateStyle(ElementObject,EditorRT.Config.UIRowEventStyle);
		let ElementRowUIFunction = (ObjectData,Event) => {
			let ConfigKeys = [];
			switch(Event.type){
				case 'click':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Click)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Click[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mouseup':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Up)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Up[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mousedown':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Down)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Down[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mousemove':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Hover)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Hover[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'drag':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drag)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Drag[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragstart':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragStart)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragStart[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragend':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnd)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragEnd[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragover':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragOver)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragOver[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragenter':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnter)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragEnter[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragleave':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragLeave)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragLeave[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'drop':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drop)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Drop[ConfigKeys[F]](ObjectData,Event);
					}
				break;
			}
		}
		EDMAddEvent(EditorRT.Id,ElementObject,'click',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'mouseup',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'mousedown',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'mousemove',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'drag',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'dragstart',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'dragend',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'dragover',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'dragenter',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'dragleave',ElementRowUIFunction);
		EDMAddEvent(EditorRT.Id,ElementObject,'drop',ElementRowUIFunction);
		let ElementRowUI = document.createElement("div");
		ElementRowUI.classList.add("edm-editor-row-selector-ui");
		ElementObject.appendChild(ElementRowUI);
		let BlockConfigTemp = JSON.parse(JSON.stringify(BlockConfig));
		BlockConfigTemp.Type = BlockConfigTemp.Type + 'Raw';
		ElementObject.appendChild(EDMGenerateRender(EditorRT,BlockConfigTemp));
		let ElementRowUIOverlay = document.createElement("div");
		EDMGenerateClass(ElementRowUIOverlay,[...EditorRT.Config.UIRowClass,...["edm-editor-row-selector-ui-overlay"]]);
		EDMGenerateAttribute(ElementRowUIOverlay,EditorRT.Config.UIRowAttribute);
		EDMGenerateStyle(ElementRowUIOverlay,EditorRT.Config.UIRowStyle);
		if(BlockConfig.Properties.HTMLUI != null){
			ElementRowUIOverlay.insertAdjacentHTML('beforeend',BlockConfig.Properties.HTMLUI);
		}
		ElementObject.appendChild(ElementRowUIOverlay);
		break;
		case 'RowRaw':
		ElementObject = document.createElement("table");
		EDMGenerateClass(ElementObject,[...EditorRT.Config.GlobalClass['table'],...EditorRT.Config.DefaultClass['table'],...(BlockConfig.Properties.Class||[])]);
		EDMGenerateAttribute(ElementObject,{...EditorRT.Config.GlobalAttribute['table'],...EditorRT.Config.DefaultAttribute['table'],...(BlockConfig.Properties.Attribute||{})});
		EDMGenerateStyle(ElementObject,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.GlobalStyle['table'],...EditorRT.Config.DefaultStyle['table'],...(BlockConfig.Properties.Style||{})}));
		let ElementTableBody = document.createElement("tbody");
		let ElementTableRow = document.createElement("tr");
		let ElementTableData = document.createElement("td");
		EDMGenerateClass(ElementTableData,EditorRT.Config.GlobalClass['td']);
		EDMGenerateAttribute(ElementTableData,EditorRT.Config.GlobalAttribute['td']);
		EDMGenerateStyle(ElementTableData,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['td']));
		ElementObject.appendChild(ElementTableBody);
		ElementTableBody.appendChild(ElementTableRow);
		ElementTableRow.appendChild(ElementTableData);
		let ElementTableContent = document.createElement("table");
		EDMGenerateClass(ElementTableContent,EditorRT.Config.GlobalClass['table']);
		EDMGenerateAttribute(ElementTableContent,EditorRT.Config.GlobalAttribute['table']);
		EDMGenerateStyle(ElementTableContent,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.GlobalStyle['table']));
		let ElementTableContentBody = document.createElement("tbody");
		let ElementTableContentRow = document.createElement("tr");
		ElementTableData.appendChild(ElementTableContent);
		ElementTableContent.appendChild(ElementTableContentBody);
		ElementTableContentBody.appendChild(ElementTableContentRow);
		break;
		case 'Col':
		ElementObject = document.createElement("td");
		ElementObject.classList.add("edm-editor-col-selector");
		EDMGenerateClass(ElementObject,[...EditorRT.Config.GlobalClass['td'],...(BlockConfig.Properties.Class||[])]);
		EDMGenerateAttribute(ElementObject,{...EditorRT.Config.GlobalAttribute['td'],...(BlockConfig.Properties.Attribute||{})});
		EDMGenerateStyle(ElementObject,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.GlobalStyle['td'],...(BlockConfig.Properties.Style||{}),...{['width']:(EditorRT.Config.TableDataLength * BlockConfig.Properties.Length) + 'px'}}));
		let ElementColUI = document.createElement("div");
		ElementColUI.setAttribute("id",BlockConfig.Id);
		EDMGenerateClass(ElementColUI,[...EditorRT.Config.UIColClass,...["edm-editor-col-selector-ui"]]);
		EDMGenerateAttribute(ElementColUI,EditorRT.Config.UIColAttribute);
		EDMGenerateStyle(ElementColUI,EditorRT.Config.UIColStyle);
		ElementObject.appendChild(ElementColUI);
		
		let ElementColUIFunction = (ObjectData,Event) => {
			let ConfigKeys = [];
			switch(Event.type){
				case 'click':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Click)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Click[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mouseup':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Up)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Up[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mousedown':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Down)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Down[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mousemove':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Hover)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Hover[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'drag':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drag)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Drag[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragstart':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragStart)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragStart[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragend':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnd)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragEnd[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragover':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragOver)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragOver[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragenter':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnter)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragEnter[ConfigKeys[F]](ObjectData,Event);
					}
				
				break;
				case 'dragleave':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragLeave)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragLeave[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'drop':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drop)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Drop[ConfigKeys[F]](ObjectData,Event);
					}
				break;
			}
		}
		EDMAddEvent(EditorRT.Id,ElementColUI,'click',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'mouseup',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'mousedown',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'mousemove',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'drag',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'dragstart',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'dragend',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'dragover',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'dragenter',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'dragleave',ElementColUIFunction);
		EDMAddEvent(EditorRT.Id,ElementColUI,'drop',ElementColUIFunction);
		let ElementColData = document.createElement("span");
		ElementColData.classList.add("edm-editor-col-data");
		ElementObject.appendChild(ElementColData);
		let ElementColUIOverlay = document.createElement("div");
		ElementColUIOverlay.setAttribute("id",BlockConfig.Id);
		EDMGenerateClass(ElementColUIOverlay,[...EditorRT.Config.UIColClass,...["edm-editor-col-selector-ui-overlay"]]);
		EDMGenerateAttribute(ElementColUIOverlay,EditorRT.Config.UIColAttribute);
		EDMGenerateStyle(ElementColUIOverlay,EditorRT.Config.UIColStyle);
		if(BlockConfig.Properties.HTMLUI != null){
			ElementColUIOverlay.insertAdjacentHTML('beforeend',BlockConfig.Properties.HTMLUI);
		}
		ElementObject.appendChild(ElementColUIOverlay);
		break;
		case 'ColRaw':
		ElementObject = document.createElement("td");
		EDMGenerateClass(ElementObject,[...EditorRT.Config.GlobalClass['td'],...(BlockConfig.Properties.Class||[])]);
		EDMGenerateAttribute(ElementObject,{...EditorRT.Config.GlobalAttribute['td'],...(BlockConfig.Properties.Attribute||{})});
		EDMGenerateStyle(ElementObject,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.GlobalStyle['td'],...(BlockConfig.Properties.Style||{}),...{['width']:(EditorRT.Config.TableDataLength * BlockConfig.Properties.Length) + 'px'}}));
		break;
		case 'Content':
		ElementObject = document.createElement("table");
		ElementObject.classList.add("edm-editor-content-selector");
		EDMGenerateClass(ElementObject,EditorRT.Config.ContentClass['table']);
		EDMGenerateAttribute(ElementObject,EditorRT.Config.ContentAttribute['table']);
		EDMGenerateStyle(ElementObject,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.ContentStyle['table']));
		let ElementTableBodyContent = document.createElement("tbody");
		let ElementTableRowContent = document.createElement("tr");
		let ElementTableDataContent = document.createElement("td");
		ElementObject.appendChild(ElementTableBodyContent);
		ElementTableBodyContent.appendChild(ElementTableRowContent);
		ElementTableRowContent.appendChild(ElementTableDataContent);
		EDMGenerateClass(ElementTableDataContent,[...EditorRT.Config.ContentClass['td'],...(BlockConfig.Properties.Class||[])]);
		EDMGenerateAttribute(ElementTableDataContent,{...EditorRT.Config.ContentAttribute['td'],...(BlockConfig.Properties.Attribute||{})});
		EDMGenerateStyle(ElementTableDataContent,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.ContentStyle['td'],...(BlockConfig.Properties.Style||{})}));
		if(BlockConfig.Properties.Content != null && BlockConfig.Properties.Content.Type != null){
			ElementTableDataContent.insertAdjacentHTML( 'afterbegin', EDMGenerateRender(EditorRT,{...BlockConfig.Properties.Content,...{ParentStyle:BlockConfig.Properties.Style || {}}}) );
		}
		let ElementContentUI = document.createElement("div");
		ElementContentUI.setAttribute("id",BlockConfig.Id);
		EDMGenerateClass(ElementContentUI,[...EditorRT.Config.UIContentClass,...["edm-editor-content-selector-ui"]]);
		EDMGenerateAttribute(ElementContentUI,EditorRT.Config.UIContentAttribute);
		EDMGenerateStyle(ElementContentUI,EditorRT.Config.UIContentStyle);
		if(BlockConfig.Properties.HTMLUI != null){
			ElementContentUI.insertAdjacentHTML('beforeend',BlockConfig.Properties.HTMLUI);
		}
		ElementTableDataContent.appendChild(ElementContentUI);
		
		let ElementContentUIFunction = (ObjectData,Event) => {
			let ConfigKeys = [];
			switch(Event.type){
				case 'click':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Click)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Click[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mouseup':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Up)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Up[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mousedown':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Down)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Down[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'mousemove':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Hover)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Hover[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'drag':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drag)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Drag[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragstart':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragStart)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragStart[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragend':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnd)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragEnd[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragover':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragOver)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragOver[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'dragenter':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragEnter)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragEnter[ConfigKeys[F]](ObjectData,Event);
					}
				
				break;
				case 'dragleave':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.DragLeave)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.DragLeave[ConfigKeys[F]](ObjectData,Event);
					}
				break;
				case 'drop':
					ConfigKeys = Object.keys(EditorRT.Config.EventFunction.Drop)
					for(let F = 0;F < ConfigKeys.length;F++){
						EditorRT.Config.EventFunction.Drop[ConfigKeys[F]](ObjectData,Event);
					}
				break;
			}
		}
		EDMAddEvent(EditorRT.Id,ElementContentUI,'click',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'mouseup',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'mousedown',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'mousemove',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'drag',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'dragstart',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'dragend',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'dragover',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'dragenter',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'dragleave',ElementContentUIFunction);
		EDMAddEvent(EditorRT.Id,ElementContentUI,'drop',ElementContentUIFunction);
		break;
		case 'ContentRaw':
		ElementObject = document.createElement("table");
		EDMGenerateClass(ElementObject,EditorRT.Config.ContentClass['table']);
		EDMGenerateAttribute(ElementObject,EditorRT.Config.ContentAttribute['table']);
		EDMGenerateStyle(ElementObject,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],EditorRT.Config.ContentStyle['table']));
		let ElementTableBodyContentRaw = document.createElement("tbody");
		let ElementTableRowContentRaw = document.createElement("tr");
		let ElementTableDataContentRaw = document.createElement("td");
		ElementObject.appendChild(ElementTableBodyContentRaw);
		ElementTableBodyContentRaw.appendChild(ElementTableRowContentRaw);
		ElementTableRowContentRaw.appendChild(ElementTableDataContentRaw);
		EDMGenerateClass(ElementTableDataContentRaw,[...EditorRT.Config.ContentClass['td'],...(BlockConfig.Properties.Class||[])]);
		EDMGenerateAttribute(ElementTableDataContentRaw,{...EditorRT.Config.ContentAttribute['td'],...(BlockConfig.Properties.Attribute||{})});
		EDMGenerateStyle(ElementTableDataContentRaw,EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],{...EditorRT.Config.ContentStyle['td'],...(BlockConfig.Properties.Style||{})}));
		if(BlockConfig.Properties.Content != null && BlockConfig.Properties.Content.Type != null){
			ElementTableDataContentRaw.insertAdjacentHTML( 'afterbegin', EDMGenerateRender(EditorRT,{...BlockConfig.Properties.Content,...{ParentStyle:BlockConfig.Properties.Style || {}}}) );
		}
		break;
		case 'blank':
		return '<div class="edm-editor-blank">Sample</div>';
		break;
		default:
		return (EditorRT.Config.ContentPlugin[BlockConfig.Type]?EditorRT.Config.ContentPlugin[BlockConfig.Type]({...{ViewMode:EditorRT.Config.ViewMode,ParentStyle:BlockConfig.ParentStyle},...BlockConfig.Properties,...{Style:EDMGenerateStyleString(EDMGenerateTypeRuleCheck(EditorRT.Config.ViewMode == 'legacy'?EditorRT.Config.LegacyFilterOut:[],BlockConfig.Properties.Style||{}))}}):'')||'';
	}
	return ElementObject
}

var EDMGetObjectOffset = function(el){
    let rect = el.getBoundingClientRect(),
	scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    }
}

var EDMGetRandomId = function () {
	let text = "";
	let possibleSymbol = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz" ;

	for (let F = 0; F < 40; F++) {
		text += possibleSymbol.charAt(Math.floor(Math.random() * possibleSymbol.length));
	}
	return text;
}

if (!Object.keys) {
  Object.keys = function(Obj) {
    var keys = [];

    for (var F in Obj) {
      if (Obj.hasOwnProperty(F)) {
        keys.push(F);
      }
    }

    return keys;
  };
}
